"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getAllConfigs;

var _defaultConfigStubJs = _interopRequireDefault(require("../../stubs/defaultConfig.stub.js"));

var _featureFlags = require("../featureFlags");

function getAllConfigs(config) {
  var ref;
  var configs = ((ref = config === null || config === void 0 ? void 0 : config.presets) !== null && ref !== void 0 ? ref : [_defaultConfigStubJs.default]).slice().reverse().flatMap(function (preset) {
    return getAllConfigs(preset instanceof Function ? preset() : preset);
  });
  var features = {
    // Add experimental configs here...
    respectDefaultRingColorOpacity: {
      theme: {
        ringColor: {
          DEFAULT: "#3b82f67f"
        }
      }
    }
  };
  var experimentals = Object.keys(features).filter(function (feature) {
    return (0, _featureFlags).flagEnabled(config, feature);
  }).map(function (feature) {
    return features[feature];
  });
  return [config].concat(_toConsumableArray(experimentals), _toConsumableArray(configs));
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}